// basically static property
let trackedInvestmentStats = ["armor_charge_capacity", "armor_charge_duration_tier", "armor_charge_duration", "armor_charge_capacity", "armor_charge_duration", "fragment_energy_capacity", "fragment_cost", "armor_energy", 'mobility', 'resilience', 'recovery', 'discipline', 'intellect', 'strength'];

let statsChanges = {};
trackedInvestmentStats.forEach(
    key => {
        statsChanges[key] = 0;
    }
);

export class UniversalSocket
{
     constructor(masterItem, effect_container, effect_type, slotIndex=null)
    {
        this.masterItem = masterItem;
        this.slotIndex = slotIndex;

        this.effect_container = effect_container;
        this.effect_type = effect_type;
        this.default_id = null;
        this.current_id = null;

        this.is_active = true;

        // part of Observer pattern
        this.subscribers = new Set();
    }

    notifySubscribers()
    {

        console.log(this.current_id)
        let effect = this.effect_container.get(this.current_id)

        let img;
        let watermark = null;

        if (effect != null)
        {
            if (effect.display_properties != null)
            {
                img = effect.display_properties.icon;
                watermark = effect.display_properties.watermark;
            }
            else
                img = "solar.png";
        }
        else
            img = "solar.png";

        this.subscribers.forEach((subscriber) => subscriber.timeForUpdate(this.is_active, img, watermark));
    }

    subscribe(subscriber)
    {
        this.subscribers.add(subscriber);
    }

    unsubscribe(subscriber) {
        this.subscribers.delete(subscriber);
    }

    set(new_id)
    {
        if (new_id == null) return;

        this.default_id = '';

        this.effect_container.remove_item(this.current_id);

        let oldId = this.current_id;

        this.default_id = new_id;
        this.current_id = new_id;

        this.effect_container.add_item(new_id);

        this.investmentStatsOnReplace(oldId, new_id);

        this.notifySubscribers();
    }

    investmentStatsOnReplace(oldId, newId)
    {

        let oldItem = this.effect_container.get(oldId);
        let newItem = this.effect_container.get(newId);
        console.log(oldId, newId)

        if (oldItem != null)
        {
            if (oldItem.investment_stats != null)
            {
                for (let stat of oldItem.investment_stats)
                {
                    //console.log(stats.id, stats.value);

                    if (stat.id in statsChanges)
                    {
                        if (stat.condition != null)
                        {
                            if (this.effect_container.master.check_condition(stat.condition))
                            {
                                statsChanges[stat.id] -= stat.value;
                            }
                        }
                        else
                        {
                            statsChanges[stat.id] -= stat.value;
                        }
                    }
                }
            }
        }

        if (newItem.investment_stats != null)
        {
            for (let stat of newItem.investment_stats)
            {
                //console.log(stats.id, stats.value);
                if (stat.id in statsChanges)
                {
                    if (stat.condition != null)
                    {
                        if (this.effect_container.master.check_condition(stat.condition))
                        {
                            statsChanges[stat.id] += stat.value;
                        }
                    }
                    else
                    {
                        statsChanges[stat.id] += stat.value;
                    }
                }
            }
        }

        console.log('stat changes:', statsChanges);

        if ("updateStats" in this.masterItem)
        {
            this.masterItem.updateStats(statsChanges);
        }

        /// clearing statChanges because it is global variable
        for (let key in statsChanges) {
          statsChanges[key] = 0;
        }
    }

    activate()
    {
        if (!this.is_active)
        {
            this.effect_container.add_item(this.current_id);
            this.is_active = true;

            this.notifySubscribers();
        }
    }

    deactivate()
    {
        if (this.is_active)
        {
            this.effect_container.remove_item(this.current_id);
            this.is_active = false;

            this.notifySubscribers();
        }
    }

    get_element()
    {
        return this.effect_container.get(this.current_id).get_element();
    }

    get_default()
    {
        return this.default_id;
    }

    get_current()
    {   console.log(this.current_id)
        return this.current_id;
    }

    get_element()
    {
        return this.effect_container.get(this.current_id).get_element();
    }

    swapValue(otherSlot)
    {
        let temp;
        console.log("swap", this, otherSlot)
        temp = otherSlot.current_id;
        otherSlot.current_id = this.current_id;
        this.current_id = temp;

        temp = otherSlot.default_id;
        otherSlot.default_id = this.default_id;
        this.default_id = temp;

        console.log("swap", this, otherSlot)

        this.notifySubscribers();
    }
}

export class AbilitySocket extends UniversalSocket
{
    constructor(masterItem, effect_container, effect_type, slotIndex=null)
    {
        super(masterItem, effect_container, effect_type, slotIndex);

        this.energy = 0;
        //this.overriden = false;
    }

    set(new_id)
    {
        if (new_id == null) return;

        //console.log('ability_storage.set', this.current_id, new_id);

        this.default_id = '';
        this.effect_container.remove_item(this.current_id);
        this.default_id = new_id;
        this.current_id = new_id;
        this.effect_container.add_item(new_id);
        this.energy = 0;

        this.notifySubscribers();

        //let ability_type = this.effect_container.get(new_id).type;

        console.log(`APP/ABILITYCTR: SET(): default_id: ${this.default_id} current_id: ${this.current_id}`);
    }

    override(override_id)
    {
        //console.log('*******************************ability_storage.override stage 1');
        this.effect_container.add_item(override_id);
        //console.log('*******************************ability_storage.override stage 2');
        this.effect_container.remove_item(this.default_id);

        this.current_id = override_id;
        let ability_type = this.effect_container.get(override_id).type;

        this.energy = 0;
        //this.overriden = true;

        this.notifySubscribers();

        console.log(`APP/ABILITYCTR: OVERRIDE(): default_id: ${this.default_id} current_id: ${this.current_id}`);
    }

    rollback()
    {
        console.log('rollback_ability')
        this.effect_container.remove_item(this.current_id);
        this.current_id = this.default_id;
        this.effect_container.add_item(this.current_id);
        let ability_type = this.effect_container.get(this.current_id).type;

        this.energy = 0;

        this.notifySubscribers();

        console.log(`APP/ABILITYCTR: ROLLBACK(): default_id: ${this.default_id} current_id: ${this.current_id}`);
    }

    get_cooldown()
    {
        if (this.current_id == null)
            return 1;

        return this.effect_container.get(this.current_id).get_cooldown();
    }

    override_cooldown(new_value)
    {
        console.log('ability_container override_cooldown(), new value:', new_value);
        let ability = this.effect_container.get(this.current_id);
        ability.cooldown.value = new_value;
        console.log(ability.cooldown);
    }

    rollback_cooldown()
    {
        let ability = this.effect_container.get(this.current_id);
        ability.cooldown.reset(1);
        //console.log('ability_container reset_cooldown(), new value:', this.get_cooldown());
    }
}
